import * as XLSX from "xlsx";
import dayjs from "dayjs";
import { message } from "antd";
import { UsimOrderItemData } from "../../../../api/usim/orders/UsimOrderItem";
import { Dayjs } from "dayjs";

const formatDateISO = (date?: Dayjs | string) => {
  if (!date) return "";
  return date instanceof dayjs ? date.format("YYYY-MM-DD") : dayjs(date).format("YYYY-MM-DD");
};
// Add export column mapping
const exportColumnMapping = {
  OrderNumber: "Order Number",
  orderProcessedDate: "Order Processed Date",
  type: "Product Type",
  sku: "SKU",
  iccid: "ICCID/SN",
  status: "Status",
  activationDate: "Activation Date",
  mobileNumber: "Mobile Number",
  ShopId: "Shop ID",
  createdAt: "Created At",
  updatedAt: "Updated At"
};


export const handleExport = async ({ processedData, filteredInfo }: { processedData: UsimOrderItemData[], filteredInfo: Record<string, any>}) => {
    try {
      // Apply all active filters to get the current filtered data
      const currentData = processedData.filter(item => {
        // Apply all active filters
        for (const [key, filterValue] of Object.entries(filteredInfo)) {
          if (!filterValue || filterValue.length === 0) continue;

          const itemValue = item[key as keyof UsimOrderItemData];
          if (!itemValue) return false;

          // Handle different filter types
          if (key === 'type' || key === 'status') {
            if (!filterValue.some((val: string) =>
              itemValue.toString().toUpperCase() === val.toString().toUpperCase()
            )) {
              return false;
            }
          }
        }
        return true;
      });

      if (currentData.length === 0) {
        message.warning("No data to export");
        return;
      }

      // Prepare data for export
      const exportData = currentData.map(item => ({
        [exportColumnMapping.OrderNumber]: item.OrderNumber || "",
        [exportColumnMapping.orderProcessedDate]: item.orderProcessedDate ? formatDateISO(item.orderProcessedDate) : "",
        [exportColumnMapping.type]: item.type || "",
        [exportColumnMapping.sku]: item.sku || "",
        [exportColumnMapping.iccid]: item.iccid || "", // No prefix, will format as text in Excel
        [exportColumnMapping.status]: item.status || "",
        [exportColumnMapping.activationDate]: item.activationDate ? formatDateISO(item.activationDate) : "",
        [exportColumnMapping.mobileNumber]: item.mobileNumber || "", // No prefix, will format as text in Excel
        [exportColumnMapping.ShopId]: item.shopId || "",
        [exportColumnMapping.createdAt]: item.createdAt ? formatDateISO(item.createdAt) : "",
        [exportColumnMapping.updatedAt]: item.updatedAt ? formatDateISO(item.updatedAt) : ""
      }));

      // Create a new workbook and worksheet
      const worksheet = XLSX.utils.json_to_sheet(exportData);

      // Apply text format to ICCID column
      const range = XLSX.utils.decode_range(worksheet["!ref"] || "");
      for (let row = range.s.r + 1; row <= range.e.r; row++) {
        const cellAddress = XLSX.utils.encode_cell({ r: row, c: 4 }); // Column 4 is ICCID
        if (!worksheet[cellAddress]) continue;
        worksheet[cellAddress].z = "@"; // Set format as text
      }

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, "Orders");

      // Generate Excel file and trigger download
      const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });
      const blob = new Blob([excelBuffer], { type: "application/octet-stream" });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);

      link.href = url;
      link.download = `orders-export-${new Date().toISOString().split("T")[0]}.xlsx`;
      link.style.visibility = "hidden";

      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      message.success(`Exported ${exportData.length} orders successfully as Excel file`);
    } catch (error) {
      console.error("Export error:", error);
      message.error("Failed to export data. Please try again.");
    }
  };